import { logError } from '@core/logging';
import { ApiResponse, BaseApiResponse, HttpResponse } from '@core/swagger-client';
import { useContext, useState } from 'react';
import { serializeError } from 'serialize-error';
import { AuthContext } from '../components';

export const useUploadFile = (url: string) => {
    const [isSuccess, setIsSuccess] = useState(false);
    const [progress, setProgress] = useState(0);
    const authorizationToken = useContext(AuthContext).token;

    // Using axios here because not sure the swagger generated client supports
    // progress updates
    const upload = async (file: FormData) => {
        try {
            const headers = new Headers();
            headers.append('Authorization', `Bearer ${authorizationToken}`);
            const response = (await fetch(url, {
                method: 'POST',
                body: file,
                headers: headers
            })) as HttpResponse<ApiResponse<boolean>, BaseApiResponse>;

            setIsSuccess(true);
            setProgress(100);
            return response.data;
        } catch (error) {
            logError('Error uploading file', { Error: serializeError(error), FileName: (file as any)['file'].name, Url: url });
            // Do something
            throw error;
        }
    };

    return { upload, isSuccess, progress };
};
